/**
 * Forgot Password Page
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Button, Input } from '../../components/ui';
import { api } from '../../lib/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string>();
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setError('E-Mail ist erforderlich');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Ungültige E-Mail-Adresse');
      return;
    }
    setError(undefined);
    setIsLoading(true);
    try {
      await api.post('/auth/request-password-reset', { email, origin: 'admin' });
    } catch {
      // Do not reveal whether the account exists
    } finally {
      setIsLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">FleetTracko Admin</h1>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          {submitted ? (
            <div className="text-center">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                E-Mail gesendet
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Falls ein Konto mit dieser E-Mail-Adresse existiert, haben wir Ihnen einen Link zum
                Zurücksetzen des Passworts gesendet.
              </p>
              <Link
                to="/login"
                className="text-sm text-primary-600 hover:text-primary-500 font-medium"
              >
                Zurück zur Anmeldung
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                Passwort vergessen?
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen
                Ihres Passworts.
              </p>
              <form onSubmit={handleSubmit} className="space-y-6">
                <Input
                  label="E-Mail"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={error}
                  placeholder="ihre.email@firma.de"
                  autoComplete="email"
                  disabled={isLoading}
                />
                <Button type="submit" className="w-full" loading={isLoading}>
                  Link senden
                </Button>
              </form>
              <div className="mt-6 text-center">
                <Link
                  to="/login"
                  className="text-sm text-primary-600 hover:text-primary-500 font-medium"
                >
                  Zurück zur Anmeldung
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
